import { render, staticRenderFns } from "./VaultCheckersQueueTable.vue?vue&type=template&id=67423f48&scoped=true&"
import script from "./VaultCheckersQueueTable.vue?vue&type=script&lang=js&"
export * from "./VaultCheckersQueueTable.vue?vue&type=script&lang=js&"
import style0 from "./VaultCheckersQueueTable.vue?vue&type=style&index=0&id=67423f48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67423f48",
  null
  
)

export default component.exports